/**
 * MetricBadge.jsx — Phase 12 mandate #1
 *
 * Visual indicator next to any metric label showing whether it is
 * Measured / Projected / Predicted. Pulls color + wording from
 * metric_classification.js so the classification is defined ONCE.
 */
import React from "react";
import { classify, TIER_META } from "./metric_classification";
import { InfoTip } from "../components/InfoTip";

export default function MetricBadge({ metricId, size = "sm" }) {
  const tier = classify(metricId);
  if (!tier) return null;
  const meta = TIER_META[tier];
  if (!meta) return null;

  const sizes = {
    xs: { padding: "1px 6px", fontSize: 9,  iconSize: 9  },
    sm: { padding: "2px 7px", fontSize: 10, iconSize: 10 },
    md: { padding: "3px 9px", fontSize: 11, iconSize: 11 },
  };
  const s = sizes[size] || sizes.sm;

  return (
    <span
      data-testid={`metric-badge-${metricId}`}
      data-tier={tier}
 
      style={{
        display:      "inline-flex",
        alignItems:   "center",
        gap:          4,
        padding:      s.padding,
        borderRadius: 999,
        background:   meta.soft,
        color:        meta.color,
        border:       `1px solid ${meta.line}`,
        fontSize:     s.fontSize,
        fontWeight:   700,
        lineHeight:   1.2,
        whiteSpace:   "nowrap",
        fontFamily:   "-apple-system, BlinkMacSystemFont, 'Noto Naskh Arabic', sans-serif",
        fontVariantNumeric: "lining-nums tabular-nums",
      }}
    ><InfoTip text={`${meta.label} — ${meta.short}`} />
      <span aria-hidden style={{ fontSize: s.iconSize }}>{meta.icon}</span>
      {meta.label}
    </span>
  );
}
